import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MenuButtonComponent } from './menu-button.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [
    MenuButtonComponent
  ],
  providers: [],
  declarations: [MenuButtonComponent]
})
export class MenuButtonModule {}
